module.exports = __webpack_public_path__ + "media/images/index_dots-f467b6466e5a94a664adf0f8157ea341.png";